export const state = () => ({
  userInformation: {
    data: null,
    isLoaded: false,
  },
});
